import gql from 'graphql-tag';

export const editUserInformation = gql`
  mutation userEdit(
    $firstName: String
    $lastName: String
    $email: String
    $phoneNumber: String
    $identityDocumentType: String
    $identityDocumentCode: String
  ) {
    userEdit(
      firstName: $firstName
      lastName: $lastName
      email: $email
      phoneNumber: $phoneNumber
      identityDocumentType: $identityDocumentType
      identityDocumentCode: $identityDocumentCode
    )
  }
`;
